$(function() {
    let categories = $("[data-filter-category]")
    let posts = $("[data-category]")

    /**
     * Filter by category
     */
    categories.on("click", function(e) {
        e.preventDefault()
        let selected = $(this)
        let filter = selected.data("filterCategory")
        // Active the category
        categories.removeClass("active")
        selected.addClass("active")
        // Filter the list
        if (filter === "all") {
            posts.removeClass("d-none")
        } else {
            posts.removeClass("d-none")
            posts.not(`[data-category=${filter}]`).addClass("d-none")
        }
    })    
})